module.exports = __webpack_public_path__ + "static/form-success-badge-4c305dae35bede2238d23bbbb1356f12.png";